/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdUsers = "/custom_objects/:type_name/:external_id/users" as const;
